import { Component, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  error: Error | null
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error, info: unknown) {
    // Keep the UI alive and surface the error in the console for debugging.
    console.error('Render error:', error, info)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="panel px-6 py-6">
          <h2 className="text-2xl font-display">Something went wrong</h2>
          <p className="mt-2 text-sm text-calamity-text-dim">
            A rendering error occurred. Try reloading the page.
          </p>
          <pre className="mt-4 max-h-64 overflow-auto rounded-xl bg-black/30 p-4 text-xs text-red-100">
            {this.state.error.message}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-full border border-calamity-border px-4 py-2 text-xs uppercase tracking-[0.2em] text-calamity-text transition hover:shadow-glow"
          >
            Reload
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

